import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as stripe from '@stripe/stripe-js';
import { firstValueFrom } from 'rxjs';
import { LoggerService } from '../logger';

import { InjectionToken } from '@angular/core';

export const STRIPE_TOKEN = new InjectionToken<string>('stripeToken');

@Injectable()
export class StripeService {
    constructor(private logger: LoggerService, private http: HttpClient, @Inject(STRIPE_TOKEN) private stripeToken: string) {
        if (window.Stripe) {
            this.stripe = window.Stripe(this.stripeToken);
            this.stripeElements = this.stripe.elements();
        } else {
            this.logger.error('Unable to load Stripe, no lib found');
        }
    }

    stripe: stripe.Stripe;
    stripeElements: stripe.StripeElements;
    createdElements = {};

    style: any = {
        style: {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        }
    };

    private createElement(elementName: any, domElement: any) {
        if (this.createdElements[elementName] === undefined) {

            this.createdElements[elementName] = this.stripeElements.create(elementName, this.style);
        }

        this.createdElements[elementName].mount(domElement);

        return this.createdElements[elementName];
    }

    createCardElement(domElement: any) {
        return this.createElement('card', domElement);
    }

    createCardNumberElement(domElement: any) {
        return this.createElement('cardNumber', domElement);
    }

    createCardExpiryElement(domElement: any) {
        return this.createElement('cardExpiry', domElement);
    }

    createCardCvcElement(domElement: any) {
        return this.createElement('cardCvc', domElement);
    }

    createPaymentMethod(card: stripe.StripeCardElement, email: string, address: CustomerAddress) {
        return this.stripe
            .createPaymentMethod({
                type: 'card',
                card: card,
                billing_details: {
                    email: email,
                    name: address.name,
                    address: {
                        city: address.addressCity,
                        country: address.countryCode,
                        line1: address.addressLine1,
                        line2: address.addressLine2,
                        postal_code: address.addressZip
                    }
                },
            })
    }

    async createCustomerAndSubscription(paymentMethodId: string, teamId: string, currency: string, vatNumber: string, customerAddress: CustomerAddress) {
        return firstValueFrom(this.http.post<any>('/api/team/' + teamId + '/subscription/new', {
            paymentMethodId: paymentMethodId,
            currency: currency,
            vatNumber: vatNumber,
            customerAddress: customerAddress
        }, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            observe: 'response'
        }))
    }

    async start3DSecure(client_secret: string): Promise<stripe.PaymentIntentResult> {
        return this.stripe
            .confirmCardPayment(client_secret);
    }

}

export interface CustomerAddress {
    name: string;
    addressLine1: string;
    addressLine2: string;
    addressCity: string;
    addressZip: string;
    countryCode: string;
}